import _ from 'underscore';
import Backbone from 'backbone';
import config from 'config';
import Global from 'models/Global';
import Track from './Track';
import PollCollection from './PollCollection';
import ViewableMixin from './ViewableMixin';
import '../backbone-relational-isomorphic';
import twitterText from 'twitter-text';

var Session = Backbone.RelationalModel.extend({
    relations: [
        {
            type: Backbone.HasMany,
            key: 'tracks',
            relatedModel: Track,
            collectionType: Backbone.Collection
        }
    ],

    defaults: {
        markersData: {}
    },

    initialize: function() {
    },

    performAction: function(options, action, method, data) {
        options = options || {};
        method = method || 'POST';
        data.eventId = Global.get('event').get('id');

        Backbone.ajax({
            url: '/api/v2/userProfile/markers',
            method: method,
            data,
            success: options.success,
            error: options.error
        });
    },

    like: function(options) {
        options = options || {};
        const thisModel = this;
        const shouldLike = options.shouldLike;
        const success = options.success;
        const data = {
            markerType: 'like',
            entity: 'sessions',
            entityId: this.get('id')
        };
        options.success = function() {
            const markersData = thisModel.get('markersData');
            if (shouldLike) {
                markersData.likeCount = markersData.likeCount ? markersData.likeCount + 1 : 1;
            } else {
                markersData.likeCount = markersData.likeCount ? markersData.likeCount - 1 : null;
            }
            markersData.like = shouldLike;
            thisModel.trigger('sessionLike');
            success && success();
        };
        this.performAction(options, 'like', shouldLike? 'POST': 'DELETE', data);
    },

    addToCalendar: function(options) {
        options = options || {};
        const success = options.success;
        const thisModel = this;
        const shouldAdd = options.shouldAdd;
        const data = {
            markerType: 'addToCal',
            entity: 'sessions',
            entityId: this.get('id')
        };

        options.success = function() {
            thisModel.get('markersData').addToCal = shouldAdd;
            thisModel.trigger('sessionFavorite');
            success && success();
        };
        this.performAction(options, 'addToCalendar', shouldAdd? 'POST': 'DELETE', data);
    },

    setPolls: function(polls) {
        const sessionPolls = polls.filter(function(poll) {
            return _.contains(poll.get('sessionIds'), this.get('id'));
        }, this);
        this.set('hasPolls', sessionPolls && sessionPolls.length > 0);
        this.set('polls', new PollCollection(sessionPolls));
    },

    hasVisibleTracks: function() {
        var visibleTracks = this.get('tracks').findWhere({disabled: false});
        return !!visibleTracks;
    },

    toJSON: function() {
        var toJSON = Backbone.RelationalModel.prototype.toJSON.call(this);
        toJSON.polls = (toJSON.polls && toJSON.polls.toJSON && toJSON.polls.toJSON()) || toJSON.polls || [];
        toJSON.safeHtmlDescription = twitterText.autoLinkUrlsCustom(twitterText.htmlEscape('' + (toJSON.description || '')), {urlTarget: '_top'});
        toJSON.safeHtmlDescription = toJSON.safeHtmlDescription.replace(/(?:\r\n|\r|\n)/g, '<br />');
        return toJSON;
    }

});
_.extend(Session.prototype, ViewableMixin);

export default Session;

